import React from 'react';
import { string, bool, object, node } from 'prop-types';
import classnames from 'classnames';
import { Tag } from '@fiverr-private/fit';
import { EducationTooltip, TooltipIcon } from '@fiverr-private/orca';
import { I18n } from '@fiverr-private/i18n-react';
import { grey_800 } from '@fiverr-private/sass/helpers';
import './style.scss';

const copyPrefix = 'notable_clients';

const TopClientsTitle = ({
    sellerName,
    infoIcon = true,
    newBadge = false,
    title = <I18n k={`${copyPrefix}.among_my_clients`}/>,
    classNames = {},
    educate,
    isWrapped
}) => (
    <div className={classnames('notable-clients-title', classNames.wrapper)}>
        <span className={classNames.title}>
            <b className="title text-semi-bold">{title}</b>
            &nbsp;
        </span>
        { educate ? (
            <EducationTooltip title={<I18n k={`${copyPrefix}.top_clients`}/>}
                body={<I18n k={`${copyPrefix}.welcome`} params={{ sellerName }}/>}
                boxClassName={classnames(
                    'notable-clients-education-box',
                    { 'm-t-12': isWrapped }
                )}
                badgeTitle={<I18n k={`${copyPrefix}.new`}/>}
                closeTitle={<I18n k={`${copyPrefix}.got_it`}/>}
                tooltipStorageKey="notableClients_bar_ed"
                position={EducationTooltip.POSITIONS.BOTTOM}>
                    &nbsp;
            </EducationTooltip>
        ) : (<>&nbsp;</>) }
        { infoIcon && (
            <TooltipIcon color={grey_800}
                containerClassName="top-clients-tooltip-container"
                boxContentClassName="top-clients-tooltip-content"
                content={<I18n k={`${copyPrefix}.tooltip`} params={{ sellerName }}/>}/>
        )}
        { newBadge && (
            <Tag color={Tag.COLORS.PINK} className="cursor-default m-l-8">
                <I18n k={`${copyPrefix}.new`}/>
            </Tag>
        )}
    </div>
);

TopClientsTitle.propTypes = {
    sellerName: string,
    infoIcon: bool,
    newBadge: bool,
    classNames: object,
    title: node,
    educate: bool,
    isWrapped: bool
};

export default TopClientsTitle;
